import { useApi, useToaster } from "@shopexperts/shared";
import { useMutation, useQueryClient } from "@tanstack/vue-query";

export function useDeleteRedirect() {
  const api = useApi();
  const queryClient = useQueryClient();
  const toaster = useToaster();

  return useMutation({
    mutationFn: (id: number) => 
      api.admin.redirects.delete({ params: { id } }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin', 'redirects'] });
      toaster.create({
        title: "Redirect deleted successfully",
        type: "success",
      });
    },
    onError: (error: any) => {
      console.error('[useDeleteRedirect] Error:', error);
      
      const errorMessage = 
        error?.response?.data?.message || 
        error?.response?.data?.error ||
        error?.message ||
        'An error occurred while deleting the redirect.';
      
      toaster.create({
        title: "Failed to delete redirect",
        description: errorMessage,
        type: "error",
      });
    },
  });
}

